// Copyright (C) 2014 Minted Inc.
// All Rights Reserved

(function(M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Community = M.View.Community || {};


  M.View.Community.OptInExclusiveDialog = Backbone.View.extend({
    events: {
      'click .continueChangeButton': 'continueOptInClick',
      'click .cancelButton': 'cancelChangeClick'
    },

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      var html = this.template();
      this.$el.html(html);
      this.$el.dialog({
        width: 400,
        modal: true,
        dialogClass: 'optInExclusiveDialog',
        closeOnEscape: true,
        draggable: false,
        resizable: false,
        beforeClose: this.trackGAEvent
      });
      return this;
    },

    trackGAEvent: function(event) {
      var KEYDOWN_ESC = 27;
      if (event.keyCode === KEYDOWN_ESC) {
        M.GA.trackEvent(
          M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
          M.GA.TRACK_EVENT_ACTION.OPT_IN_EXCLUSIVE,
          'escape-' + this.action_type + '-dialog'
        );
      } else if (event.currentTarget &&
          event.currentTarget.classList.contains('ui-dialog-titlebar-close')) {
        M.GA.trackEvent(
          M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
          M.GA.TRACK_EVENT_ACTION.OPT_IN_EXCLUSIVE,
          'close-' + this.action_type + '-dialog'
        );
      } else {
        M.GA.trackEvent(
          M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
          M.GA.TRACK_EVENT_ACTION.OPT_IN_EXCLUSIVE,
          'cancel-' + this.action_type + '-dialog'
        );
      }
    },

    renderOverlay: function(is_exclusive, url) {
      this.url = url;
      if (is_exclusive) {
        this.template = M.Template.Community.WithdrawExclusivePrompt;
      } else {
        this.template = M.Template.Community.OptInExclusivePrompt;
      }

      if (is_exclusive) {
        this.action_type = 'exclusive'
      } else {
        this.action_type = 'non-exclusive'
      }

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECT,
        M.GA.TRACK_EVENT_ACTION.CHANGE_EXCLUSIVE_STATUS,
        'open-' + this.action_type + '-dialog'
      );
      this.render();
    },

    cancelChangeClick: function() {
      this.$el.dialog('close');
    },

    continueOptInClick: function() {
      var parsedUrl = M.Url.ParseUrl(this.url);
      this.url = parsedUrl.pathname;

      $.ajax({
        url: this.url,
        type: 'POST',
        success: function() {
          window.location.reload();
        },
        error: function() {
          window.location.reload();
        }
      });

      M.GA.trackEvent(
        M.GA.TRACK_EVENT_CATEGORY.MY_PROJECTS,
        M.GA.TRACK_EVENT_ACTION.CHANGE_EXCLUSIVE_STATUS,
        'continue-' + this.action_type
      );
    }
  });
})(M, _, $, Backbone);
